import { cssClass } from '@/shared/utils'
import { notificationCardBackground } from '../styles/notification-card.css'
import { Text } from '@/components/commons/typography/Text'
import {
  useIsOwnProfile,
  useProfile,
  useProfileById,
} from 'containers/profile/hooks/useProfile'
import { ButtonComponent } from '@/components/commons'
import { joinWithSlash } from 'utilities/links'
import { useProfilesViewers, useProfileViews } from '../hooks/useProfileViews'
import { AvatarContainer } from '../components/chart/AvatarContainer'
import Link from 'next/link'
import { useMemo } from 'react'
import { ANONYMOUS_VIEWER_ID } from '../types/profileViews'

export const ProfileViewNotification = () => {
  const { profile } = useProfile()
  const { data, isLoading } = useProfileViews()
  const { totals } = useProfilesViewers()
  const isOwnProfile = useIsOwnProfile()

  const firstProfileId = useMemo(() => {
    // take the first profile id different to ANONYMOUS_VIEWER_ID
    return totals?.public?.find((id) => id !== ANONYMOUS_VIEWER_ID)
  }, [totals?.public])

  const { profile: firstProfile, isLoading: loadingProfile } =
    useProfileById(firstProfileId)

  if (isLoading || !profile || !isOwnProfile) {
    return null
  }

  return (
    <div
      className={cssClass([
        'py-18 px-30 bg-black-primary rounded-12 border-solid border-1 border-accent-primary',
        notificationCardBackground,
      ])}
    >
      <div className="flex justify-space-between items-center--desktop gap-12 flex-column flex-row--desktop">
        <div className="">
          <Text sizeClass="text-16" colorClass="text-white">
            👀 {data.totalViews} Profile Viewers
          </Text>

          <Text sizeClass="text-14" colorClass="text-white">
            Included with{' '}
            <Text
              as="span"
              sizeClass="text-14"
              colorClass="text-info"
              weightClass="font-bold"
            >
              Creatorland Insider
            </Text>
          </Text>
        </div>

        <div className="flex items-center gap-12">
          <div className="flex">
            {firstProfile?.id &&
              totals?.public?.slice(0, 3).map((id, index) => (
                <div
                  key={id + '_avatar_profile_viewers_card'}
                  className={cssClass([
                    'relative',
                    index === 0 && 'z-20',
                    index === 1 && '-ml-8 z-10',
                    index === 2 && '-ml-10 z-0',
                  ])}
                >
                  <AvatarContainer id={id} size={32} />
                </div>
              ))}
          </div>

          {!loadingProfile && firstProfile?.id && (
            <Link href={joinWithSlash(profile?.username, 'views')}>
              <Text
                sizeClass="text-14"
                colorClass="text-white"
                className="text-underline cursor-pointer"
              >
                {firstProfile?.firstName} {firstProfile?.lastName} +{' '}
                <span className="font-bold">{data.totalViews - 1} more</span>
              </Text>
            </Link>
          )}
        </div>

        <div className="">
          <ButtonComponent
            size="xSmall"
            fullWidth
            label="View"
            variation="secondary-dark"
            to={joinWithSlash(profile?.username, 'views')}
            customSize={{
              padding: 30,
            }}
          />
        </div>
      </div>
    </div>
  )
}
